import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  BodyWrapper,
  ActionObject,
  Header,
  Loader,
  MainWrapper,
} from '@components';
import { businessQuery, locationDeleteMutation, locationQuery } from '@queries';

import { LocationBreadcrumbs } from '../components/LocationBreadcrumbs/LocationBreadcrumbs.jsx';
import { LocationSidebar } from '../components/LocationSidebar/LocationSidebar.jsx';

export const LocationSettings = () => {
  const { businessID, locationID } = useParams();
  const { t, i18n } = useTranslation();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  // Fetches business
  const { data: businessData, isPending: businessIsPending } = useQuery(
    businessQuery(businessID),
  );

  // Fetches business
  const { data: locationData, isPending: locationIsPending } = useQuery(
    locationQuery(locationID),
  );

  // delete location
  const deleteMutation = useMutation(
    locationDeleteMutation(locationID, {
      onSuccess: () => {
        // invalidate the lists so its purged
        queryClient.invalidateQueries({ queryKey: ['locations', 'list'] });
        // navigate to the list view
        navigate(`/dashboard/projects/${businessID}/locations`);
      },
    }),
  );

  return (
    <>
      <Header />
      <BodyWrapper>
        <LocationSidebar businessID={businessID} locationID={locationID} />
        <MainWrapper>
          <LocationBreadcrumbs
            businessData={businessData}
            locationData={locationData}
          >
            <li className="sb-flex">
              <span>{t('Location settings')}</span>
            </li>
          </LocationBreadcrumbs>
          <div className="sb-manage-content">
            <h1>{t('Location settings')}</h1>
            {locationIsPending && (
              <Loader className="sb-loader sb-loader-large" />
            )}
            {locationData && (
              <div className="sb-message-action-section">
                <ActionObject
                  onAction={() => deleteMutation.mutate()}
                  loading={deleteMutation.isPending}
                  actionName="Delete"
                  actionVerb="Deleting"
                  label="Delete location"
                  note="This location will be permanently deleted"
                />
              </div>
            )}
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
